import { create } from 'zustand'
import createGlobalSlice, { TGlobalSlice } from './createGlobalSlice'
import createCatalogSlice, { TCatalogSlice } from './createCatalogSlice'
import createOrderSlice, { TOrderSlice } from './createOrderSlice'

export type TCombinedTypes = TCatalogSlice & TGlobalSlice & TOrderSlice

const useBoundStore = create<TCombinedTypes>()((...a) => ({
  ...createGlobalSlice(...a),
  ...createCatalogSlice(...a),
  ...createOrderSlice(...a),
}))

export default useBoundStore
